export enum Buff {
  INNER_QUIET,

  WASTE_NOT,
  WASTE_NOT_II,

  MANIPULATION,

  GREAT_STRIDES,

  INNOVATION,

  VENERATION,

  MAKERS_MARK,

  MUSCLE_MEMORY,

  FINAL_APPRAISAL,

  HEART_AND_SOUL,

  EXPEDIENCE,

  TRAINED_PERFECTION,
}
